import { CircularProgress, Grid, Tooltip as MuiTooltip } from "@material-ui/core";
import { widgetTitleStyle } from "./style";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const WidgetTitle = ({ title,
    info,
    loading = false,
}) => {
    const classes = widgetTitleStyle();

    return <>
        <Grid container className={classes.header} justifyContent="space-between" >
            {loading &&
                <CircularProgress
                    size='1em'
                    style={{ position: 'absolute' }}
                />}
            <Grid className={classes.widgetTitle} item >
                {title}
            </Grid>
            {info &&
                <Grid item xs={1}>
                    <MuiTooltip title={info}>
                        <InfoOutlinedIcon />
                    </MuiTooltip>
                </Grid>
            }
        </Grid>
    </>
}
export default WidgetTitle;